import {withStyles} from '@material-ui/core/styles'
import React from 'react'
import {BooleanField, TopToolbar, CreateButton, Datagrid, DateField, List, SelectField, TextField,} from 'react-admin'

const styles = theme => ({
  title: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  hiddenOnSmallScreens: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }
})
const Actions = ({basePath,}) => (
  <TopToolbar>
    <CreateButton basePath={basePath}/>
  </TopToolbar>
)

export default withStyles(styles)(({classes, ...props}) => {
  return (
    <List {...props}
          actions={<Actions/>}
          perPage={25}
          bulkActionButtons={false}>
      <Datagrid rowClick="show">
        <TextField source="id" sortable={false}/>
        <SelectField source="authority" choices={[
          {id: 'admin', name: '관리자'},
          {id: 'manager', name: '매니저'},
        ]} sortable={false}/>
        <TextField source="name" sortable={false}/>
        <TextField source="adminName" sortable={false}/>
        <TextField source="affiliation" sortable={false}/>
        <TextField source="phone" sortable={false}/>
        <TextField source="email" sortable={false}/>
        <BooleanField source="emailNoti" sortable={false}/>
        <DateField source="createdAt" locales='ko' showTime sortable={false}/>
      </Datagrid>
    </List>
  )
})

